import React from "react";

export const ActivityIcon = () => (
  <svg width="28" height="28" viewBox="0 0 20 20" fill="none">
    <rect
      x="2"
      y="5"
      width="16"
      height="11"
      rx="2.5"
      fill="#F0FDF4"
      stroke="#16A34A"
      strokeWidth="1.2"
    />
    <path
      d="M3.5 10.5H6.5L8 7.5L10 13.5L12 9L13.5 11H16.5"
      stroke="#16A34A"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VitalsIcon = () => (
  <svg width="28" height="28" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 15.5S3.5 11.5 3.5 7.5C3.5 5.5 5 4 7 4c1.2 0 2.2.6 3 1.5C10.8 4.6 11.8 4 13 4c2 0 3.5 1.5 3.5 3.5 0 4-6.5 8-6.5 8Z"
      fill="#FEF2F2"
      stroke="#DC2626"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path
      d="M7 9.5h1.5L9.5 8l1.5 3 1-1.5h1"
      stroke="#DC2626"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WellnessIcon = () => (
  <svg width="28" height="28" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 2.5 3 6.5V11c0 3.5 3 6.5 7 7.5 4-1 7-4 7-7.5V6.5l-7-4Z"
      fill="#F1F5F9"
      stroke="#6A8090"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path
      d="M10 7v3.5"
      stroke="#6A8090"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <circle cx="10" cy="13" r=".9" fill="#6A8090" />
  </svg>
);

export const MobilityIcon = () => (
  <svg width="28" height="28" viewBox="0 0 100 100">
    <path
      d="M67.65 80.43c.93 1.86.11 3.89-1.52 4.79s-3.95.34-4.87-1.49l-7-13.97-10.35-10.35c-1-1-1.21-2.18-.99-3.54l2.64-15.83-7.71 1.9-6.41 9.61c-1.11 1.67-3.22 2.12-4.85 1.16s-2.38-3.29-1.23-5.02l7.24-10.88c.59-.89 1.42-1.33 2.44-1.59l13.98-3.5c1.36-.34 2.61-.02 3.61.97l10.17 10.16 10.04 3.36c1.9.63 2.84 2.72 2.2 4.59-.58 1.68-2.52 2.88-4.42 2.25l-10.98-3.64c-.51-.24-.96-.52-1.37-.89l-5.82-5.81-2.15 12.87 9.92 9.93 7.45 14.91Z"
      fill="#2E8FA0"
    />
    <path
      d="M34.93 84.13c-1.28 1.71-3.43 1.99-5.06.82-1.47-1.05-2.06-3.31-.85-4.93l10.81-14.45c1.24-1.65 3.4-2.04 5.05-.87s2.05 3.42.78 5.12l-10.74 14.32Z"
      fill="#2E8FA0"
    />
    <path
      d="M52.24 13.72c4.06-.79 7.78 1.92 8.47 5.83s-1.88 7.59-5.75 8.32-7.67-1.78-8.42-5.72 1.67-7.65 5.71-8.43Z"
      fill="#2E8FA0"
    />
  </svg>
);

export const TrendIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 3v18h18" />
    <path d="m18 9-5 5-4-4-3 3" />
  </svg>
);

export const ChevronIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path
      d="m2.5 4.5 4 4 4-4"
      stroke="#6A8090"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg width="10" height="10" viewBox="0 0 11 11" fill="none">
    <path
      d="m2 5.5 2.5 2.5L9 3"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EnvelopeIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1155CC"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2Z" />
    <path d="m22 6-10 7L2 6" />
  </svg>
);

export const SendIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 19V5" />
    <path d="m5 12 7-7 7 7" />
  </svg>
);

export const ShareIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4" />
  </svg>
);

export const MicIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="9" y="2" width="6" height="12" rx="3" />
    <path d="M5 10a7 7 0 0 0 14 0" />
    <path d="M12 17v4M8 21h8" />
  </svg>
);

export const iconForCard = (icon) => {
  if (icon === "activity") return <ActivityIcon />;
  if (icon === "vitals") return <VitalsIcon />;
  if (icon === "wellness") return <WellnessIcon />;
  return <MobilityIcon />;
};

// Rounded two-squares copy glyph (pharmacy sheets).
export const RoundedCopyIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="8" y="8" width="13" height="13" rx="3.5" />
    <path d="M16 8V6.5A3.5 3.5 0 0 0 12.5 3h-6A3.5 3.5 0 0 0 3 6.5v6A3.5 3.5 0 0 0 6.5 16H8" />
  </svg>
);
